import { render, staticRenderFns } from "./AdoptionReportSchool.vue?vue&type=template&id=ed8a2710&"
import script from "./AdoptionReportSchool.vue?vue&type=script&lang=js&"
export * from "./AdoptionReportSchool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports